module.exports = __webpack_public_path__ + "img/logo-2.3739acae.webp";